<p-toast [style]="{ marginTop: '80px' }"></p-toast>
<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>

<p-table
  #pt
  [value]="employeeAcqPayments"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  dataKey="employeeAcqPaymentId"
  selectionMode="single"
  [(selection)]="employeeAcqPayment"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"
  [paginator]="showPagination"
  [rows]="25"
  [rowsPerPageOptions]="[25, 100, 200]"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [totalRecords]="recordTotal"
  sortMode="multiple"
  [multiSortMeta]="multiSortMeta"
  styleClass="p-datatable-striped"
  [ngStyle]="{ width: 'auto' }"
  [resizableColumns]="true"
  [autoLayout]="true"
  [responsive]="true"
  >
  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left; margin: 6px">Employee Acq Payments</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button
            pButton
            pRipple
            class="p-button-text"
          style="
            font-size: 80%;
            padding: 0.643rem 0.75rem !important;
            margin-right: 10px;
          "
            (click)="reloadPage()"
            >
            Clear Filters
          </button>
        }

        <!--add new-->
        <button
          pButton
          pRipple
          class="p-button"
          style="padding: 0.643rem 0.75rem !important"
          (click)="onOpenFormAdd()"
          >
          New Employee Acq Payment +
        </button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th
          [pSortableColumn]="col.field"
          [ngStyle]="{ width: col.width }"
          >
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{ width: 'auto' }"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="propertyProfilesList" appendTo="body"
            (onChange)="pt.filter($event.value, 'propertyProfileId', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="propertyName" optionValue="propertyProfileId">
            <ng-template let-option pTemplate="item">
              <span>{{option.propertyName}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="employeeAgnt1List" appendTo="body"
            (onChange)="pt.filter($event.value, 'agnt1UserVO.firstName', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="firstName" optionValue="firstName">
            <ng-template let-option pTemplate="item">
              <span>{{option.firstName}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="employeeAgnt2List" appendTo="body"
            (onChange)="pt.filter($event.value, 'agnt2UserVO.firstName', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="firstName" optionValue="firstName">
            <ng-template let-option pTemplate="item">
              <span>{{option.firstName}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="realtorProfilesList" appendTo="body"
            (onChange)="pt.filter($event.value, 'realtorProfileId', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="firstName" optionValue="realtorProfileId">
            <ng-template let-option pTemplate="item">
              <span>{{option.firstName}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="number"
        (input)="pt.filter($event.target.value, 'estGrossRev', 'in')"></th>
        <th>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="number"
        (input)="pt.filter($event.target.value, 'compAcqAgent1PayDate1Amount', 'in')"></th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="statuses" appendTo="body"
            (onChange)="pt.filter($event.value, 'compAcqAgent1PayDate1Status', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="number"
        (input)="pt.filter($event.target.value, 'compAcqAgent1PayDate2Amount', 'in')"></th>
        <th>
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="statuses" appendTo="body"
            (onChange)="pt.filter($event.value, 'compAcqAgent1PayDate2Status', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-employeeAcqPayment>
    <tr [pSelectableRow]="employeeAcqPayment">
      <td>{{ getPropertyName(employeeAcqPayment) }}</td>
      <td>{{ employeeAcqPayment?.contractSignDate | date}}</td>
      <td>{{ employeeAcqPayment?.agnt1?.firstName }}</td>
      <td>{{ employeeAcqPayment?.agnt2?.firstName }}</td>
      <td>{{ getRealtorName(employeeAcqPayment) }}</td>
      <td>{{ employeeAcqPayment.estGrossRev | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
      <td>{{ employeeAcqPayment.compAcqAgent1PayDate1 | date }}</td>
      <td>{{ employeeAcqPayment.compAcqAgent1PayDate1Amount }}</td>
      <td>{{ employeeAcqPayment.compAcqAgent1PayDate1Status }}</td>
      <td>{{ employeeAcqPayment.compAcqAgent1PayDate2 | date }}</td>
      <td>{{ employeeAcqPayment.compAcqAgent1PayDate2Amount }}</td>
      <td>{{ employeeAcqPayment.compAcqAgent1PayDate2Status }}</td>
      <td>
        <span style="float: none">
          <a>
            <i
              class="pi pi-pencil"
              aria-hidden="true"
              style="color: blue; font-size: 110%; padding-right: 20px"
              (click)="onOpenFormEdit(employeeAcqPayment)"
            ></i>
          </a>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
